import React, { useState, useEffect } from 'react';
import { Swords, ChevronRight, Target, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../../api/client';

const FriendChallengeCard = () => {
  const navigate = useNavigate();
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.request('/api/advanced-engagement/friend-challenges')
      .then(data => setChallenges((data.challenges || []).filter(c => ['active', 'pending'].includes(c.status))))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;

  const active = challenges.filter(c => c.status === 'active');
  const pending = challenges.filter(c => c.status === 'pending');

  return (
    <div
      className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl p-5 border border-indigo-200 cursor-pointer hover:shadow-md transition-all"
      onClick={() => navigate('/friend-challenges')}
      data-testid="friend-challenge-dashboard-card"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-lg bg-indigo-100 flex items-center justify-center">
            <Swords size={20} className="text-indigo-600" />
          </div>
          <div>
            <p className="text-sm font-bold text-gray-900">Friend Challenges</p>
            <p className="text-xs text-gray-500">Practice together</p>
          </div>
        </div>
        <ChevronRight size={18} className="text-gray-400" />
      </div>

      {active.length > 0 ? (
        <div className="space-y-2">
          {active.slice(0, 2).map(c => (
            <div key={c.challenge_id} className="flex items-center gap-2 p-2 bg-white/60 rounded-lg">
              <Target size={14} className="text-indigo-500 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs font-semibold text-gray-800 truncate">{c.title}</p>
                <p className="text-[10px] text-gray-400">with {c.friend_name?.split(' ')[0]}</p>
              </div>
              <span className="text-[10px] font-bold text-indigo-600">{c.creator_progress}/{c.goal_count}</span>
            </div>
          ))}
        </div>
      ) : pending.length > 0 ? (
        <div className="flex items-center gap-2 p-2 bg-amber-50 rounded-lg">
          <Users size={14} className="text-amber-600" />
          <p className="text-xs font-medium text-amber-800">{pending.length} pending invite{pending.length > 1 ? 's' : ''}</p>
        </div>
      ) : (
        <p className="text-xs text-gray-400">Challenge a friend to grow together!</p>
      )}
    </div>
  );
};

export default FriendChallengeCard;
